import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

const Navbar = () => {
  const navigate = useNavigate();
  const username = localStorage.getItem("username");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    navigate("/login");
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <nav className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white p-4 flex justify-between items-center">
      <h1 className="text-xl font-bold">Totle<span className="text-[yellow]">soft</span></h1>

      {/* Dropdown button for mobile screens */}
      <button
        className="md:hidden focus:outline-none"
        onClick={toggleDropdown}
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M4 6h16M4 12h16m-7 6h7"
          ></path>
        </svg>
      </button>

      {/* Navbar links for larger screens */}
      <div className="hidden md:flex space-x-6 font-[500]">
        <Link to="/">Home</Link>
        {username ? (
          <Link to="/gallery">My Gallery</Link>
        ) : (
          <Link to="/login">Gallery</Link>
        )}
      </div>

      {/* User-related links for larger screens */}
      <div className="hidden md:flex items-center space-x-4">
        {username ? (
          <>
            <span>Welcome, {username}</span>
            <button
              onClick={handleLogout}
              className="bg-red-500 px-4 py-2 rounded"
            >
              Logout
            </button>
          </>
        ) : (
          <>
            <Link to="/login">Login</Link>
            <Link to="/register">Register</Link>
          </>
        )}
      </div>

      {/* Dropdown menu for mobile screens */}
      {isDropdownOpen && (
        <div className="md:hidden absolute top-16 right-4 bg-gradient-to-r from-purple-600 to-indigo-600 text-white p-4 rounded shadow-lg">
          <div className="flex flex-col space-y-4">
            <Link to="/" onClick={toggleDropdown}>
              Home
            </Link>
            {username ? (
              <Link to="/gallery" onClick={toggleDropdown}>
                My Gallery
              </Link>
            ) : (
              <Link to="/login" onClick={toggleDropdown}>
                Gallery
              </Link>
            )}
            {username ? (
              <>
                <span>Welcome, {username}</span>
                <button
                  onClick={handleLogout}
                  className="bg-red-500 px-4 py-2 rounded"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={toggleDropdown}>
                  Login
                </Link>
                <Link to="/register" onClick={toggleDropdown}>
                  Register
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;